import * as S from "./styles";

import { useEffect, useState } from "react";

import ReprocessarPagamento from "../../ReprocessarPagamento";
import BookingsRepository from "../../../repositories/bookingsRepository";
import CivitatisExperienceRepository from "../../../repositories/civitatisExperienceRepository";
import { useGlobal } from "../../../contexts/globalContext";
import PlaceIcon from "@material-ui/icons/Place";
import Loader from "../../Loader";
import { useHistory } from "react-router-dom";
import Auth2faModal from "../../Auth2FaModal";

import { ThemeButton } from "../../ThemeButton/styles";
import ImageIcon from "@material-ui/icons/Image";

import { format, isDate, parseISO } from "date-fns";
import { pt } from "date-fns/locale";
import { safeFormat } from "../../../utils/dateHelpers";

const EntertainmentCard = ({
  booking = {},
  departureDate,
  arrivalDate,
  coinAlias,
}) => {
  let history = useHistory();

  const bookingsRepository = new BookingsRepository();
  const { showAlert } = useGlobal();

  const [openDialogReprocessar, setOpenDialogReprocessar] = useState(false);
  const [openLoader, setOpenLoader] = useState(false);
  const [openModal2fa, setOpenModal2fa] = useState(false);
  const [image, setImage] = useState(null);
  const [imageLoadError, setImageLoadError] = useState(false);

  // Demanda 251 — voucher da Civitatis. Nada disso vem gravado na reserva:
  // é consultado no clique e vive só enquanto o card estiver aberto.
  const [voucherLoading, setVoucherLoading] = useState(false);
  const [voucherUrls, setVoucherUrls] = useState([]);

  const activityName =
    booking?.bookingService?.entertainment?.name ||
    booking?.bookingService?.civitatis?.activityName ||
    booking?.description ||
    "Atividade";
  const activityLocation =
    booking?.bookingService?.entertainment?.location ||
    booking?.bookingService?.civitatis?.activityLocation ||
    "Local não especificado";
  const activityDescription =
    booking?.bookingService?.entertainment?.description ||
    booking?.bookingService?.civitatis?.activityDescription ||
    "Sem descrição disponível";

  // Busca passageiros de múltiplas fontes
  const getPassengers = () => {
    if (booking.passengers && booking.passengers.length > 0) {
      return booking.passengers;
    }
    if (booking?.bookingService?.civitatis?.passengers && booking.bookingService.civitatis.passengers.length > 0) {
      return booking.bookingService.civitatis.passengers;
    }
    return [];
  };

  useEffect(() => {
    // Os cards da lista são chaveados por índice: sem limpar, os links de uma
    // reserva podem reaparecer sob outra quando a lista é filtrada ou reordenada.
    setVoucherUrls([]);
  }, [booking?.bookingCode]);

  useEffect(() => {
    if (booking?.bookingService?.entertainment?.image) {
      setImage(booking.bookingService.entertainment.image);
    } else if (booking?.bookingService?.civitatis?.image) {
      setImage(booking.bookingService.civitatis.image);
    } else if (booking?.bookingService?.civitatis?.voucherUrls && booking.bookingService.civitatis.voucherUrls.length > 0) {
      setImage(booking.bookingService.civitatis.voucherUrls[0]);
    } else if (booking?.voucherUrls && booking.voucherUrls.length > 0) {
      setImage(booking.voucherUrls[0]);
    }
  }, [booking]);

  const closeModal2fa = () => setOpenModal2fa(false);

  const isCivitatis = booking?.type === "CIVITATIS-EXPERIENCE";

  /**
   * Demanda 251 — busca os links do voucher na hora do clique.
   *
   * Um item pode ter mais de um documento (voucher, e-ticket, ingresso), então
   * com vários links a gente lista em vez de abrir tudo: o bloqueador de
   * pop-up do navegador só deixa passar a primeira janela.
   */
  const baixarVoucher = async () => {
    setVoucherLoading(true);

    try {
      const civitatisRepository = new CivitatisExperienceRepository();
      const resultado = await civitatisRepository.getVoucher(
        booking?.bookingCode || booking?.locator,
      );
      const urls = resultado?.data?.urls || [];

      if (!resultado?.success) {
        showAlert("error", resultado?.error || "Não foi possível consultar o voucher agora.");
        return;
      }

      if (urls.length === 0) {
        showAlert(
          "info",
          "O voucher ainda não foi emitido pela Civitatis. Assim que ficar pronto, enviaremos por e-mail.",
        );
        return;
      }

      setVoucherUrls(urls);

      // Um documento só: abre direto, ainda dentro do gesto do usuário.
      if (urls.length === 1) {
        window.open(urls[0], "_blank", "noopener");
      }
    } catch (error) {
      showAlert("error", "Não foi possível consultar o voucher agora.");
    } finally {
      setVoucherLoading(false);
    }
  };

  const onChangeOpenDialogReprocessar = (open) =>
    setOpenDialogReprocessar(open);

  const getStatusTranslate = (status) => {
    switch (status) {
      case 1:
        return "pendente";
      case 2:
        return "emitido";
      case 3:
        return "expirado";
      case 4:
        return "finalizado";
      case 5:
        return "cancelado";
      default:
        return "desconhecido";
    }
  };

  const reprocessar = () => {
    if (
      (booking.paymentTransaction === null ||
        booking.paymentTransaction === undefined) &&
      booking.cashTotalValue > 0
    ) {
      onChangeOpenDialogReprocessar(true);
    } else {
      setOpenLoader(true);
      bookingsRepository
        .reprocessarPagamento(booking.bookingCode, {})
        .then((res) => {
          setOpenLoader(false);
          sessionStorage.setItem("@bookingCompleted", JSON.stringify(res));
          switch (res.status) {
            case 200:
              history.push("/busca/finalizado");
              break;
            case 201:
              if (res.data.auth2fa) {
                if (res.data.redirectAuth2fa !== null) {
                  setOpenLoader(true);
                  window.location.replace(res.data.redirectAuth2fa);
                } else {
                  setOpenModal2fa(true);
                }
              } else {
                history.push("/busca/finalizado");
              }
              break;
            default:
              break;
          }
        })
        .catch((err) => {
          setOpenLoader(false);
          switch (err?.response?.status) {
            case 400:
              showAlert("Há algo de errado nos seus dados, verifique!");
              break;
            case 401:
              history.push("/session-expires");
              break;
            case 409:
              sessionStorage.setItem(
                "@bookingError",
                JSON.stringify(err.response.data.error)
              );
              sessionStorage.setItem(
                "reprocessar",
                JSON.stringify({ reprocessar: true })
              );
              history.push("/busca/booking-error");
              break;
            case 504:
              sessionStorage.setItem(
                "@bookingError",
                JSON.stringify("Tempo expirou, tente novamente!")
              );
              sessionStorage.setItem(
                "reprocessar",
                JSON.stringify({ reprocessar: true })
              );
              history.push("/busca/booking-error");
              break;
            default:
              showAlert(
                "error",
                `Compra não processada, por favor, tente novamente!`
              );
              break;
          }
        });
    }
  };

  const reenviarVoucher = (locator) => {
    bookingsRepository
      .reenviarVoucher(locator)
      .then((res) =>
        showAlert("success", "Voucher reenviado, verifique seu e-mail!")
      )
      .catch((err) => showAlert("error", "Houve algum erro, tente novamente!"));
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";

    try {
      if (typeof dateString === "string") {
        if (isDate(parseISO(dateString))) {
          return safeFormat(dateString, "dd/MM/yyyy", { locale: pt });
        }
      }

      const date = new Date(dateString);
      if (!isNaN(date)) {
        return format(date, "dd/MM/yyyy", { locale: pt });
      }

      return "";
    } catch (error) {
      console.error("Erro ao formatar data:", error);
      return "";
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";

    try {
      if (typeof dateString === "string") {
        if (isDate(parseISO(dateString))) {
          return safeFormat(dateString, "dd/MM/yyyy HH:mm", {
            locale: pt,
          });
        }
      }

      const date = new Date(dateString);
      if (!isNaN(date)) {
        return format(date, "dd/MM/yyyy HH:mm", { locale: pt });
      }

      return "";
    } catch (error) {
      console.error("Erro ao formatar data e hora:", error);
      return "";
    }
  };

  return (
    <S.BlankCard>
      <ReprocessarPagamento
        open={openDialogReprocessar}
        onClose={onChangeOpenDialogReprocessar}
        booking={booking}
      />
      <Loader openLoader={openLoader} />
      <Auth2faModal
        open={openModal2fa}
        onClose={closeModal2fa}
        booking={{ data: booking }}
        type="reprocessar"
      />
      <S.CardHeader>
        <S.Title>
          Código da reserva: {booking?.bookingCode || booking?.locator || "N/A"}
          <span className="subtitle">
            Data da reserva:{" "}
            {formatDate(booking?.bookingDateStr || booking?.bookingDate)}
          </span>
        </S.Title>
        {booking?.statusId && (
          <S.StatusContainer>
            {booking?.statusId === 1 && (
              <ThemeButton className="reprocessar" onClick={reprocessar}>
                Reprocessar Pagamento
              </ThemeButton>
            )}
            {booking?.statusId === 2 && (
              <ThemeButton
                className="reprocessar"
                onClick={() =>
                  reenviarVoucher(booking?.bookingCode || booking?.locator)
                }
              >
                Reenviar Voucher
              </ThemeButton>
            )}

            {/* Demanda 251 — o voucher oficial da Civitatis. O e-mail da
                Destino Férias é comprovante de compra; o documento que vale
                no dia da atividade é este. */}
            {isCivitatis && booking?.statusId === 2 && (
              <ThemeButton
                className="reprocessar"
                disabled={voucherLoading}
                onClick={baixarVoucher}
              >
                {voucherLoading ? "Consultando..." : "Baixar Voucher(s)"}
              </ThemeButton>
            )}

            <S.Status
              className={`status ${getStatusTranslate(booking.statusId)}`}
            >
              {getStatusTranslate(booking.statusId)}
            </S.Status>
          </S.StatusContainer>
        )}
      </S.CardHeader>

      {/* A lista aparece SEMPRE que há documento, inclusive com um só.
          O `window.open` acontece depois do await da consulta, ou seja, fora do
          gesto do usuário — o navegador bloqueia. Sem esta lista, o caso de um
          documento (o mais comum) terminava sem abrir nada e sem aviso. */}
      {voucherUrls.length > 0 && (
        <S.Subtitle>
          Documentos da atividade:{" "}
          {voucherUrls.map((url, index) => (
            <a
              key={`${url}-${index}`}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginRight: "12px", textDecoration: "underline" }}
            >
              Documento {index + 1}
            </a>
          ))}
        </S.Subtitle>
      )}

      <S.Subtitle>Detalhes da atividade</S.Subtitle>

      <S.FlightSummaryCardDetails>
        <div style={{
          width: "200px",
          height: "200px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: (image && !imageLoadError) ? "transparent" : "#f0f0f0",
          borderRadius: "8px"
        }}>
          {image && !imageLoadError ? (
            <img
              src={image}
              alt={`Imagem de ${activityName}`}
              style={{
                width: "200px",
                height: "200px",
                objectFit: "cover",
                borderRadius: "8px",
              }}
              onError={() => setImageLoadError(true)}
            />
          ) : (
            <ImageIcon style={{ fontSize: "60px", color: "#ccc" }} />
          )}
        </div>
        <S.HotelDetails item xs={12}>
          <div className="content">
            <div className="hotel-details">
              <span className="hotel-name">{activityName}</span>
            </div>
          </div>
          <div className="roomDetails">
            {activityDescription && (
              <span>
                <b>Descrição:</b> {activityDescription}
              </span>
            )}
            <br />

            <span style={{ color: "#ff5757" }}>
              <b>Política de cancelamento:</b> Para maiores detalhes, consulte o
              voucher encaminhado ao seu e-mail.
            </span>
          </div>
        </S.HotelDetails>
      </S.FlightSummaryCardDetails>

      <S.BottomInfos>
        {getPassengers().length > 0 && (
          <S.Travellers>
            <S.Subtitle>VIAJANTES</S.Subtitle>
            {getPassengers().map((passenger, index) => (
              <S.TravellerName key={index}>
                {`${passenger.name || passenger.firstName || "Nome"}`}
              </S.TravellerName>
            ))}
          </S.Travellers>
        )}

        {booking.pointsTotalValue ? (
          <S.ValorTotal>
            Valor em {coinAlias || "pontos"}: {booking.pointsTotalValue}
          </S.ValorTotal>
        ) : null}

        {booking.cashTotalValue ? (
          <S.ValorTotal>
            Valor em R$: {booking.cashTotalValue.toLocaleString("pt-BR")}
          </S.ValorTotal>
        ) : null}
      </S.BottomInfos>

      <S.ExpirationDate>
        <span>
          {booking?.bookingService?.expirationDate && (
            <span>
              <b>Esta reserva expira em: </b>{" "}
              {formatDateTime(booking.bookingService.expirationDate)}
            </span>
          )}
        </span>
      </S.ExpirationDate>
    </S.BlankCard>
  );
};

export default EntertainmentCard;
